import { action, computed, makeAutoObservable, runInAction } from 'mobx'
import { Store } from '@stores'
import { MatchScoreWeekMeta } from '../api/weeks.api'

export class WeeksStore {
  _store: Store
  loading: boolean
  match_score: any[] | null
  match_score_week: MatchScoreWeekMeta | null
  specifications: any[] | null
  specifications_week: MatchScoreWeekMeta | null

  constructor(store: Store) {
    makeAutoObservable(this)
    this._store = store
    this.loading = false
    this.match_score = null
    this.match_score_week = null
    this.specifications = null
    this.specifications_week = null
  }

  @computed
  get is_loading() {
    return this.loading
  }

  @computed
  get watch_match_score() {
    return this.match_score
  }

  @computed
  get watch_match_score_week() {
    return this.match_score_week
  }

  @computed
  get watch_specifications() {
    return this.specifications
  }

  @computed
  get watch_specifications_week() {
    return this.specifications_week
  }

  @action
  async getSpecifications(id: string | number) {
    this.loading = true
    try {
      const res = await this._store.api.weeks.get_specifications(id)
      runInAction(() => {
        this.specifications = Array.isArray(res?.data) ? res.data : []
        this.specifications_week = res?.meta?.week ?? null
      })
      return res
    } finally {
      runInAction(() => {
        this.loading = false
      })
    }
  }

  @action
  async getMatchScore(id: string | number) {
    this.loading = true
    try {
      const res = await this._store.api.weeks.get_match_score(id)
      runInAction(() => {
        this.match_score = Array.isArray(res?.data) ? res.data : []
        this.match_score_week = res?.meta?.week ?? null
      })
      return res
    } finally {
      runInAction(() => {
        this.loading = false
      })
    }
  }
}
